import { render, staticRenderFns } from "./AiContextSettingsTab.vue?vue&type=template&id=24a1a4ca&scoped=true"
import script from "./AiContextSettingsTab.vue?vue&type=script&lang=js"
export * from "./AiContextSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./AiContextSettingsTab.vue?vue&type=style&index=0&id=24a1a4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1a4ca",
  null
  
)

export default component.exports